import React, { useEffect, useState } from 'react';
import AboutDescription from '../About-description/AboutDescription';
import AboutCards from "../AboutCards/AboutCards";
import AboutTitle from '../AboutTitle/AboutTitle';
import { IoIosArrowUp } from "react-icons/io";
import classes from "./About.module.css";

export default function About() {
  const [showBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <section className={classes.About} id="about">
      <div className="container">
        <div className="row between-sm between-xs">
          <div className="col-md-12 col-sm-5 col-xs-12">
            <AboutTitle title={"ABOUT"} sub={"us"} about={true} />
            <AboutDescription />
          </div>
          <AboutCards />
        </div>
      </div>
      {showBtn ?
        <div className={classes.pageUp_btn}>
          <button onClick={goToTop}>
            <IoIosArrowUp />
          </button>
        </div> :
        ""
      }
    </section>
  )
}
